import Axios, { AxiosRequestConfig, AxiosError } from 'axios';
import { parseAxiosError } from '../../errors/parseApiError';
import type { ApiError } from '../../errors/types';
import { API_BASE_URL } from '../apiBaseUrl';

const BASE_URL = API_BASE_URL;

// Public-only Axios instance: no cookie, no X-Tenant-Id.
// Used for /api/v1/public/* endpoints that must work anonymously
// from the marketing page and the contact form.
export const publicAxiosInstance = Axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: false,
});

publicAxiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const apiError = parseAxiosError(error);
    (error as AxiosError & { apiError?: ApiError }).apiError = apiError;
    return Promise.reject(error);
  },
);

export const publicCustomInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const source = Axios.CancelToken.source();

  const promise = publicAxiosInstance({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }) => data);

  // @ts-expect-error - Cancel function wird dynamisch hinzugefügt
  promise.cancel = () => {
    source.cancel('Query was cancelled');
  };

  return promise;
};

export default publicCustomInstance;
